<template>
    <div class="tab-lv flex font-bold  text-center text-14 lg:text-16">
        <div v-for="(tab, index) of tabs"
            :key="index"
            class="h-10 flex-1 flex flex-col justify-center cursor-pointer"
            :class="[activeTab == index ? activeTabStyle : 'text-a-brown-502314']"
            @click="clickTab(index, index)">
            {{localeCode == 1033 ? tab.name_en : tab.name}}
        </div>
    </div>
</template>
<script>
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: "TabLevel",
    mixins: [LocaleMixin],
    props: {
        tabs: Array,
    },
    data: function() {
        return {
           activeTab: '0',
           activeTabStyle: 'text-a-red-d62300 border-b-4 border-a-red-d62300',
        }
    },
    methods: {
        clickTab: function(index, selectedTab){
            this.activeTab = selectedTab;
            let sendIno = {
                index: index,
                tabName: selectedTab
            }
            this.$emit('clickTab', sendIno);
        }
    },
}
</script>
